export class Condicional{
    operando1:string;
    comparacion:string;
    operando2:string;
    instruccion:string;

    constructor(operando1:string,comparacion:string,operando2:string,instruccion:string){
        this.operando1 = operando1;
        this.comparacion = comparacion;
        this.operando2 = operando2;
        this.instruccion = instruccion;
    }

}